import { CatalogCategoriesContext } from "../context/CatalogCategoriesContext";
import { useContext } from "react";

export const useCatalogCategoriesContext = () => {
  const context = useContext(CatalogCategoriesContext);

  if (!context) {
    throw Error(
      "useCatalogCategoriesContext must be used inside a CatalogCategoriesContextProvider"
    );
  }

  return context;
};